module.exports = __webpack_public_path__ + "static/img/img10.85ae32e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img10.png
// module id = jJ76
// module chunks = 1